type RuntimeEnvKey =
  | "VITE_BACKEND_URL"
  | "VITE_DEPLOYMENT_ENVIRONMENT"
  | "VITE_MAX_UPLOAD_FILE_SIZE_BYTES"
  | "VITE_APP_VERSION";

declare global {
  var __RUNTIME_ENV__: Partial<Record<RuntimeEnvKey, string>> | undefined;
}

// injected by the container entrypoint into public/env.js, which loads before
// the bundle; falls back to build-time env so dev and tests keep working
export function runtimeEnv(key: RuntimeEnvKey): string | undefined {
  // presence, not truthiness: the entrypoint always writes every key, so an
  // empty one means "deliberately unset" and must not fall back to a value
  // baked in at build time
  const injected = globalThis.__RUNTIME_ENV__;
  if (injected && key in injected) {
    return injected[key];
  }

  const fallback: unknown = import.meta.env[key];
  return typeof fallback === "string" && fallback ? fallback : undefined;
}

// accepts either an absolute origin ("https://api.example.com") or a
// same-origin subpath ("/api"); the trailing slash is stripped because callers
// concatenate paths straight onto this value and would otherwise emit "//"
export function backendBaseUrl(): string {
  const configured = runtimeEnv("VITE_BACKEND_URL") ?? "";
  // scanned rather than stripped with /\/+$/, whose backtracking is quadratic
  // on a long run of slashes
  let end = configured.length;
  while (end > 0 && configured[end - 1] === "/") end--;
  return configured.slice(0, end);
}

// otel only needs an explicit propagation list for cross-origin requests, but
// it matches against fully resolved request urls, so a subpath base has to be
// widened to an absolute url or it would never match
export function absoluteBackendBaseUrl(): string {
  const base = backendBaseUrl();
  if (!base) {
    return "";
  }
  return new URL(base, globalThis.location.origin).href;
}

// the chart injects the deployed image tag (release version in production, the
// folder hash in staging); package.json's version is only a dev and test
// fallback, so an empty value counts as unset here
export function appVersion(): string {
  return runtimeEnv("VITE_APP_VERSION") || __APP_VERSION__;
}
